import { useContext } from 'react'

import { SocketContext } from 'context'

export const useSocket = (): WebSocket => {
  const socketContext = useContext(SocketContext)

  return socketContext.socket
}
